import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import drag from 'v-drag'

createApp(App).use(router).use(drag).mount('#app')